import moment from "moment/moment";

// Notifications to show all users
// format: { id: Int, notification: String, type: Enum }
let NOTIFS = [];
if (moment().isBefore(moment("2025-02-01"))) {
  NOTIFS = [
    {
      id: 'GETBENT24',
      notification: (
        <div>
          <div className="padding-b-1"><b>Your gym could have a chance to win $20K in BEИT holds!</b></div>
          Each climber who joins the Get BENT Challenge and logs a session at your gym is an entry into the giveaway for all of January. <br />
          Climbers also receive 15% discount from Tension/BEИT when they log 4+ sessions during the challenge. <br />
          <div className="padding-t-1">Join the <a target="_blank" href="https://app.kayaclimb.com/share/challenge?id=1406">Get BENT Challenge</a> on KAYA. If interested <a target="_blank" href="https://drive.google.com/drive/folders/1PxB9QNK4CglTz52jKX8DquK9pspkpAEh">promotional materials are located here</a>.</div>
        </div>
      ),
      type: 2,
    },
  ];
}
export const ACTIVE_NOTIFICATIONS = NOTIFS;
